<h3>Protect your account with Two Step Verification</h3>

<p>Each time you sign into EZLynx, you will need a verification code.</p>

<div class="detail-group">
  <mat-icon>security</mat-icon>

  <div class="detail-text">
    <strong>Add an extra layer of security</strong>

    <span class="secondary-text">
      Two step verification requires two factors, or pieces of information,
      to verify your identity.
    </span>
  </div>
</div>

<div class="detail-group">
  <mat-icon>do_not_disturb</mat-icon>

  <div class="detail-text">
    <strong>Keep the bad guys out</strong>

    <span class="secondary-text">
      Even if someone gets your password, it won't be enough for them to
      access your account.
    </span>
  </div>
</div>

@if (canSkip && enrollmentRequiredBy) {
  <div class="skip-text">
    Last chance to skip: <strong>{{ enrollmentRequiredBy | date:'M/d/YYYY' }}</strong>
  </div>
}

<div class="buttons">
  @if (canSkip) {
    <a mat-button
       id="btnSkip"
       href="./SkipEnrollment">Skip</a>
  }

  <a mat-button
     id="btnBack"
     color="primary"
     href="/auth/Account/Login">Back</a>

  <a mat-flat-button
     id="btnStart"
     color="primary"
     href="./TypeEnrollment?verificationType=SMS">Get started</a>
</div>
